registerTableLink('#invoice-table', routes['app.invoice.show'])
registerTableLink('#mail-table', routes['app.mail.show'])
registerTableLink('#message-table', routes['app.message.show'])
